import { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaGlobe, FaChevronRight } from 'react-icons/fa';
import '../css/handf/Footer.css';

const Footer = () => {
  const footerRef = useRef(null);
  const [hasAppeared, setHasAppeared] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasAppeared(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer 
      ref={footerRef} 
      className={`footer-main mt-auto ${hasAppeared ? 'animate-now' : ''}`}
    >
      <div className="footer-top py-5">
        <Container>
          <Row className="gy-5 text-center text-md-start">
            
            {/* Column 1: Links */}
            <Col 
  lg={3} 
  md={4} 
  className="animate-footer footer-col-1 d-flex flex-column align-items-center align-items-lg-start"
>
  <div className="text-center text-lg-start"> 
    <h5 className="footer-heading text-uppercase">Useful Links</h5>
    <ul className="list-unstyled footer-links-list">
      <li><a href="/how-to-do" target="_blank"  rel="noreferrer"  className="footer-link-item"><FaChevronRight className="link-icon" /> How to Do</a></li>
      <li><a href="https://c.jkbs.in/td-mega" target="_blank"  rel="noreferrer" className="footer-link-item"><FaChevronRight className="link-icon" /> Reference Documents</a></li>
      {/*<li><a href="/home" className="footer-link-item"><FaChevronRight className="link-icon" /> Home</a></li>
      <li><a href="/about" className="footer-link-item"><FaChevronRight className="link-icon" /> About Us</a></li>
      <li><a href="/services" className="footer-link-item"><FaChevronRight className="link-icon" /> Our Services</a></li>
      <li><a href="/contact" className="footer-link-item"><FaChevronRight className="link-icon" /> Contact</a></li>*/}
    </ul>
  </div>
</Col>

            {/* Column 2: Contact */}
            <Col lg={5} md={8} className="animate-footer footer-col-2">
              <h5 className="footer-heading text-uppercase">Quick Contact</h5>
              <div className="contact-info">
                <div className="contact-item mb-3">
                  <div className="icon-box"><FaPhoneAlt /></div>
                  <div className="contact-text">
                    <span className="d-block small opacity-75">Phone</span>
                    <strong>+91 73394 89005</strong>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="icon-box"><FaEnvelope /></div>
                  <div className="contact-text">
                    <span className="d-block small opacity-75">Email</span>
                    <strong>thiurpathidocumentation@gmail.com</strong>
                  </div>
                </div>
              </div>
            </Col>

            {/* Column 3: Tech Support */}
            <Col lg={4} md={12} className="animate-footer footer-col-3">
              <h5 className="footer-heading text-uppercase">Software Support</h5>
              <div className="support-card p-4 rounded-4">
                <p className="mb-3 d-flex align-items-center justify-content-center justify-content-md-start">
                  <FaPhoneAlt className="text-warning me-3" /> +91 93 4444 5252
                </p>
                <p className="mb-3 d-flex align-items-center justify-content-center justify-content-md-start">
                  <FaEnvelope className="text-warning me-3" /> dev@jasperkeyplay.com
                </p>
                <p className="mb-0 d-flex align-items-center justify-content-center justify-content-md-start">
                  <a 
                    href="https://support.jasperkeyplay.com" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-decoration-none"
                    style={{color:"white"}}
                  >
                    <FaGlobe className="text-warning me-3" />
                    support.jasperkeyplay.com
                  </a>
                </p>
              </div>
            </Col>

          </Row>
        </Container>
      </div>

      {/* Copyright Section */}
      <div className="copyright-section text-center">
        <Container className="animate-footer footer-bottom-anim">
          <div className="copyright-content py-4">
            <p className="small mb-2 opacity-75">
              Copyright Reserved 2026 | All Rights for Thirupathi Documentation is Reserved.
            </p>
            <p className="v-small opacity-50 mb-0">
              Brand names and logos used on this website are trademarks of their respective owners.
            </p>
            
            <div className="developer-tag mt-4 pt-4 border-top border-light border-opacity-10 d-inline-flex align-items-center">
              <span className="me-2 small opacity-75">POWERED BY</span>
              <a href="https://jasperkeyplay.com/?utm_source=thirupathi_doc&utm_medium=footer&utm_campaign=organic" target="_blank"  rel="noreferrer" className="footer-link-item"><span className="brand-highlight">JASPERKEYPLAY</span></a>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;